import { Chip } from '@mui/material';
import styled from 'styled-components';

import { COLORS } from '../../../theme';

export const Component = styled(Chip)`
  &.MuiChip-root {
    height: 28px;
    color: ${({ textColor }) => textColor || COLORS.black80};
    background: ${({ background }) => background || COLORS.black06};
    border: 0.5px solid ${({ border }) => border || COLORS.black80};
    cursor: inherit;
  }

  .MuiChip-label {
    padding: 0 ${({ theme }) => theme.spacing.s3};
    font-size: ${({ theme }) => theme.fontSize.body2};
    font-weight: 500;
  }

  &&& .MuiChip-icon {
    margin-right: -${({ theme }) => theme.spacing.s2};
    margin-left: ${({ theme }) => theme.spacing.s1};
    font-size: 20px;

    path {
      fill: ${({ iconColor }) => iconColor || COLORS.black50};
    }
  }

  &&& .MuiChip-deleteIcon {
    width: unset;
    margin-right: ${({ theme }) => theme.spacing.s2};
    margin-left: -${({ theme }) => theme.spacing.s1};
    font-size: 12px;

    path {
      fill: ${COLORS.black60};
    }
  }
`;
